import * as React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import BasicContentSection from '../components/basic-content-section/BasicContentSection';
import SponsorshipSection from '../components/sponsorship-section/SponsorshipSection';
import GetInvolvedPreview from '../components/get-involved-preview/GetInvolvedPreview';
import HomeLanding from '../components/home-landing/HomeLanding';
import Layout from '../components/layout/Layout';
import NavGradient from '../components/nav-gradient/NavGradient';
import {
  ContentSectionWrapper,
  LocationText,
  DateText,
  AddressText,
  DateContainer,
  LocationContainer,
  Circles,
  Mic,
  DateWrapper,
  PageContainer,
} from '../page-styles/index.style';
import HomePageDescription from '../components/home-page-description/HomePageDescription';
import { GraphicGridDesktop, GraphicGridMobile } from '../lib/shared';
import { icons } from '../style/icons';
import Countdown from 'react-countdown';
import Workshops from '../components/workshops/Workshops';
import Keynotes from '../components/keynotes/Keynotes';
import Experience from '../components/experience/Experience';
import RotatingBanner from '../components/rotating-banner/RotatingBanner';
import Head from '../components/head/Head';

const IndexPage = () => {
  const pageQuery = useStaticQuery(graphql`
    query MyQuery {
      prismicHomePage {
        data {
          days_until_conference_section {
            document {
              ... on PrismicBasicContentSection {
                id
                data {
                  button_link {
                    url
                  }
                  button_text {
                    text
                  }
                  section_description {
                    text
                  }
                  section_title {
                    text
                  }
                }
              }
            }
          }
          company_shoutout_image {
            url
          }
          conference_address {
            text
          }
          conference_blurb {
            text
          }
          conference_banner {
            text
          }
          conference_date {
            text
          }
          conference_location {
            text
          }
          home_page_content_sections {
            home_page_content_section {
              document {
                ... on PrismicBasicContentSection {
                  id
                  data {
                    button_link {
                      url
                    }
                    button_text {
                      text
                    }
                    section_description {
                      text
                    }
                    section_title {
                      text
                    }
                  }
                }
              }
            }
          }
          home_page_title {
            text
          }
          shoutout_header {
            text
          }
        }
      }
    }
  `);

  const {
    prismicHomePage: {
      data: {
        home_page_title: homePageTitle,
        days_until_conference_section: daysUntilConferenceSection,
        conference_banner: conferenceBanner,
        conference_date: conferenceDate,
        conference_location: conferenceLocation,
        conference_address: conferenceAddress,
        conference_blurb: conferenceBlurb,
        shoutout_header: shoutoutHeader,
        company_shoutout_image: companyShoutoutImage,
        home_page_content_sections: homePageContentSections,
      },
    },
  } = pageQuery;

  const eventDate = new Date('2022-04-09T09:00:00.000Z').getTime();
  const today = new Date().getTime();
  const diff = () => (eventDate - today <= 0 ? 0 : eventDate - today);

  const time = ({ days }) => {
    return (
      <BasicContentSection section={daysUntilConferenceSection} days={days} />
    );
  };

  return (
    <Layout redLine={true}>
      <Head title="Home" />
      <HomeLanding landingText={homePageTitle.text} />
      <NavGradient />
      <RotatingBanner rotatingText={conferenceBanner.text} bannerRepeat={6} />
      <PageContainer>
        <ContentSectionWrapper>
          <Countdown date={Date.now() + diff()} renderer={time} />
          <Mic src={icons.DATE_MIC.image}></Mic>
        </ContentSectionWrapper>
        <DateWrapper>
          <Circles src={icons.CIRCLES.image}></Circles>
          <DateContainer>
            <DateText>{conferenceDate.text}</DateText>
          </DateContainer>
          <LocationContainer>
            <LocationText>{conferenceLocation.text}</LocationText>
            <AddressText>{conferenceAddress.text}</AddressText>
          </LocationContainer>
        </DateWrapper>
        <HomePageDescription conferenceBlurb={conferenceBlurb} />
      </PageContainer>
      <GraphicGridDesktop
        src={icons.HOME_GRAPHIC_GRID_1_DESKTOP.image}
        alt={icons.HOME_GRAPHIC_GRID_1_DESKTOP.altText}
      />
      <GraphicGridMobile
        src={icons.HOME_GRAPHIC_GRID_1_MOBILE.image}
        alt={icons.HOME_GRAPHIC_GRID_1_MOBILE.altText}
      />
      <Keynotes
        section={homePageContentSections[0].home_page_content_section}
      />
      <Workshops
        section={homePageContentSections[1].home_page_content_section}
      />
      <Experience
        section={homePageContentSections[2].home_page_content_section}
      />
      <GraphicGridDesktop
        src={icons.HOME_GRAPHIC_GRID_2_DESKTOP.image}
        alt={icons.HOME_GRAPHIC_GRID_2_DESKTOP.altText}
      />
      <GraphicGridMobile
        src={icons.HOME_GRAPHIC_GRID_2_MOBILE.image}
        alt={icons.HOME_GRAPHIC_GRID_2_MOBILE.altText}
      />
      <SponsorshipSection heading={shoutoutHeader.text} />
      <GetInvolvedPreview />
    </Layout>
  );
};

export default IndexPage;
